export enum Course {
    AL_MAT = "A-level Maths",
    AL_FMA = "A-level Further Maths",
    AL_BIO = "A-level Biology",
    AL_CHE = "A-level Chemistry",
    AL_CS = "A-level Computer Science",
    AL_ECO = "A-level Economics",
    AL_ENG = "A-level English Language",
    AL_LIT = "A-level English Literature",
    AL_GEO = "A-level Geography",
    AL_HIS = "A-level History",
    AL_PHY = "A-level Physics",
    AL_PSY = "A-level Psychology",
    GS_BIO_H = "GCSE Biology higher",
    GS_BIO_F = "GCSE Biology foundation",
    GS_CHE_H = "GCSE Chemistry higher",
    GS_CHE_F = "GCSE Chemistry foundation",
    GS_SCI_H = "GCSE Combined science higher",
    GS_SCI_F = "GCSE Combined science foundation",
    GS_CS = "GCSE Computer Science",
    GS_ECO = "GCSE Economics",
    GS_ENG = "GCSE English Language",
    GS_LIT = "GCSE English Literature",
    GS_GEO = "GCSE Geography",
    GS_HIS = "GCSE History",
    GS_MAT_H = "GCSE Maths higher",
    GS_MAT_F = "GCSE Maths foundation",
    GS_PHY_H = "GCSE Physics higher",
    GS_PHY_F = "GCSE Physics foundation",
    GS_PSY = "GCSE Psychology",
};

export const collections: Record<Course, string> = {
    [Course.AL_MAT]: "gce_maths_item",
    [Course.AL_FMA]: "gce_further_maths_item",
    [Course.AL_BIO]: "gce_biology_item",
    [Course.AL_CHE]: "gce_chemistry_item",
    [Course.AL_CS]: "gce_computer_science_item",
    [Course.AL_ECO]: "gce_economics_item",
    [Course.AL_ENG]: "gce_english_language_item",
    [Course.AL_LIT]: "gce_english_literature_item",
    [Course.AL_GEO]: "gce_geography_item",
    [Course.AL_HIS]: "gce_history_item",
    [Course.AL_PHY]: "gce_physics_item",
    [Course.AL_PSY]: "gce_psychology_item",
    [Course.GS_BIO_H]: "gcse_biology_item",
    [Course.GS_BIO_F]: "gcse_biology_foundation_item",
    [Course.GS_CHE_H]: "gcse_chemistry_item",
    [Course.GS_CHE_F]: "gcse_chemistry_foundation_item",
    [Course.GS_SCI_H]: "gcse_combined_science_item",
    [Course.GS_SCI_F]: "gcse_combined_science_foundation_item",
    [Course.GS_CS]: "gcse_computer_science_item",
    [Course.GS_ECO]: "gcse_economics_item",
    [Course.GS_ENG]: "gcse_english_language_item",
    [Course.GS_LIT]: "gcse_english_literature_item",
    [Course.GS_GEO]: "gcse_geography_item",
    [Course.GS_HIS]: "gcse_history_item",
    [Course.GS_MAT_H]: "gcse_maths_item",
    [Course.GS_MAT_F]: "gcse_maths_foundation_item",
    [Course.GS_PHY_H]: "gcse_physics_item",
    [Course.GS_PHY_F]: "gcse_physics_foundation_item",
    [Course.GS_PSY]: "gcse_psychology_item",
};